// @flow
import { eventBus } from '@/main';
import axios from 'axios';
import { isDef, isUndef } from 'utils';
import BrowserStorage from '@/services/browser-storage';
import * as Sentry from '@sentry/browser';
import timsmartblowfish from '@/utils/timsmartblowfish';

const WEB = 'WEB';
const baseURL = process.env.VUE_APP_TIM_API;
const responseType = 'json';

const instance = axios.create({ baseURL, responseType });

instance.interceptors.request.use((config) => {
  const authToken = BrowserStorage.get('token');
  const recaptcha = BrowserStorage.get('recaptcha');

  config.headers.client = WEB;
  if (isDef(authToken) && typeof authToken === 'string') {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  if (isDef(recaptcha) && typeof recaptcha === 'string') {
    config.params = { ...config.params, recaptcha };
  }

  return config;
}, error => Promise.reject(error));

instance.interceptors.response.use((response) => {
  if (response.status === 203) {
    eventBus.$emit('event-bus-multiple-sessions', response.data.message);
  }
  if (isUndef(response.headers.Authorization) && response.data && response.data.access_token) {
    response.headers.Authorization = timsmartblowfish.decode(response.data.access_token);
  }
  if (isDef(response.headers.Authorization)) {
    BrowserStorage.set('token', response.headers.Authorization);
  }

  return response;
},
(error) => {
  Sentry.captureException(error);
  return Promise.reject(error.response);
  }
);

export default instance;
